import { render } from "./Loader.vue?vue&type=template&id=2dc85358&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=2dc85358&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2dc85358"

export default script